// src/components/CustomerSummary/components/Top3OrderingProvidersTable.jsx
// ============================================================================
// BLOCK CS.UI.TOP3PROV.0 — Top3OrderingProvidersTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 2 columns)
// - Group header rows: "<Provider>\t"
// - Nested rows (rank-only): "\t<rank>" (col1 blank)
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function Top3OrderingProvidersTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.top3OrderingProviders}
    />
  );
}
